import { lazy, Suspense } from 'react';
import { useLocation } from '@tanstack/react-router';
import { isWebview } from '@/utils/webview-detection';
import { shouldShowChatbot } from './constants';

const WebsiteChatbot = lazy(() => import('./website-chatbot'));

export function WebsiteChatbotGate() {
  const { pathname } = useLocation();

  if (!shouldShowChatbot(pathname) || isWebview()) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <WebsiteChatbot />
    </Suspense>
  );
}
